import React, { FC, memo, useCallback, useMemo } from 'react';
import { useField } from 'formik';
import { getAvailableItems } from 'data/cacheHelpers/menu';

import {
  Container,
  SelectAdd,
  Placeholder,
  PlaceholderText,
  Item,
  Name,
  ActionButton,
} from './styles';
import { Props } from './types';

const AppliesTo: FC<Props> = ({ isProcessing, brandId, ...props }) => {
  const [{ value }, , { setValue }] = useField<string[]>('usedIn');

  const { items, options } = useMemo(
    () => getAvailableItems(brandId),
    [brandId],
  );

  const itemOptions = useMemo(
    () => options.filter((option) => !value.includes(option.value)),
    [options, value],
  );

  const handleAddOption = useCallback(
    (itemToAdd: string) => {
      if (itemToAdd) {
        setValue([...value, itemToAdd]);
      }
    },
    [value, setValue],
  );

  const handleRemoveItem = useCallback(
    (itemIdToRemove) => {
      setValue(value.filter((itemId) => itemId !== itemIdToRemove));
    },
    [value, setValue],
  );

  return (
    <Container {...props}>
      <SelectAdd
        options={itemOptions}
        onAdd={handleAddOption}
        disabled={isProcessing}
      />
      {value.length === 0 && (
        <Placeholder>
          <PlaceholderText>
            You don&apos;t have any items selected yet.
          </PlaceholderText>
        </Placeholder>
      )}
      <div>
        {value.map((itemId) => (
          <Item key={itemId}>
            <Name>{items[itemId].name.displayName}</Name>
            <ActionButton
              disabled={isProcessing}
              variant="delete"
              type="button"
              onClick={() => handleRemoveItem(itemId)}
            />
          </Item>
        ))}
      </div>
    </Container>
  );
};

export default memo(AppliesTo);
